import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex h-screen bg-gray-200 font-roboto" }
const _hoisted_2 = { class: "flex-1 flex flex-col overflow-hidden" }
const _hoisted_3 = { class: "flex-1 overflow-x-hidden overflow-y-auto bg-gray-200" }
const _hoisted_4 = { class: "h-full container mx-auto p-2" }
const _hoisted_5 = {
  key: 0,
  class: "fixed z-10 inset-0 overflow-y-auto"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { className: "flex justify-center h-full" }, [
  /*#__PURE__*/_createElementVNode("div", { className: "animate-ping h-4 w-4 bg-blue-600 rounded-full m-auto" })
], -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SystemSidebar = _resolveComponent("SystemSidebar")!
  const _component_SalonSidebar = _resolveComponent("SalonSidebar")!
  const _component_SystemHeader = _resolveComponent("SystemHeader")!
  const _component_SalonHeader = _resolveComponent("SalonHeader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.is_system_role)
        ? (_openBlock(), _createBlock(_component_SystemSidebar, {
            key: 0,
            is_sidebar_open: _ctx.is_sidebar_open,
            "onSidebar:toggle": _ctx.toggleSidebarOpen,
            onSignout: _ctx.signout
          }, null, 8, ["is_sidebar_open", "onSidebar:toggle", "onSignout"]))
        : _createCommentVNode("", true),
      (!_ctx.is_system_role)
        ? (_openBlock(), _createBlock(_component_SalonSidebar, {
            key: 1,
            is_sidebar_open: _ctx.is_sidebar_open,
            "onSidebar:toggle": _ctx.toggleSidebarOpen,
            onSignout: _ctx.signout
          }, null, 8, ["is_sidebar_open", "onSidebar:toggle", "onSignout"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.is_system_role)
          ? (_openBlock(), _createBlock(_component_SystemHeader, {
              key: 0,
              is_sidebar_open: _ctx.is_sidebar_open,
              "onSidebar:toggle": _ctx.toggleSidebarOpen
            }, null, 8, ["is_sidebar_open", "onSidebar:toggle"]))
          : _createCommentVNode("", true),
        (!_ctx.is_system_role)
          ? (_openBlock(), _createBlock(_component_SalonHeader, {
              key: 1,
              is_sidebar_open: _ctx.is_sidebar_open,
              "onSidebar:toggle": _ctx.toggleSidebarOpen
            }, null, 8, ["is_sidebar_open", "onSidebar:toggle"]))
          : _createCommentVNode("", true),
        _createElementVNode("main", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ])
    ]),
    (_ctx.is_loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : _createCommentVNode("", true)
  ], 64))
}